// extracted by mini-css-extract-plugin
export default {"svg":"BackgroundGrid_svg__LfZq+","background-color":"BackgroundGrid_background-color__sJK+-"};